import { useQuery } from 'react-query'
import {
  ListSupportedCurrencies,
  ListSupportedLocales,
  MetaApi,
  ResponseError,
} from '@trybeapp/sdk'
import { apiConfiguration } from 'utilities/TrybeApiClient'
import { ApiResponse } from 'api/api.types'

const api = new MetaApi(apiConfiguration)

export const useSupportedLocales = () =>
  useQuery<ListSupportedLocales, ResponseError>(
    ['supportedLocales'],
    () => api.listMetaSupportedLocales(),
    {
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }
  )

export const useSupportedCurrencies = () =>
  useQuery<ListSupportedCurrencies, ResponseError>(
    ['supportedCurrencies'],
    () => api.listMetaSupportedCurrencies(),
    {
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }
  )

export const useSupportedTimezones = () =>
  useQuery<ApiResponse<Array<{ code: string }>>, never>(
    ['supportedTimezones'],
    () => ({ data: Intl.supportedValuesOf('timeZone').map((timezone) => ({ code: timezone })) }),
    {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }
  )
